import { AfterViewInit, EventEmitter, Input, Output, Directive } from '@angular/core';
import { Color } from '../../../constants/color.constants';
import { Icons } from '../../../constants/icons.constants';
import { Table } from '../../../constants/table.constants';
import { Paging } from '../../../models/enums';

@Directive()
export abstract class LsqBasePaginationComponent implements AfterViewInit {
    @Input() public skip = 0;
    @Input() public take = 0;
    @Input() public totalCount = 0;
    @Input() public takeOptions = Table.DefaultTakeOptions;
    @Input() public isLoading = false;
    @Output() public init = new EventEmitter();
    @Output() public skipChange = new EventEmitter<number>();
    @Output() public takeChange = new EventEmitter<number>();

    public paging = {
        next: Paging.Next,
        prev: Paging.Prev
    };
    public icons = Icons;
    public color = Color;

    // Lifecycle methods.
    public ngAfterViewInit(): void {
        this.init.emit();
    }

    // Getters.
    public get currentPage(): number {
        return this.take ? Math.floor(this.skip / this.take) + 1 : 1;
    }

    public get pageCount(): number {
        return this.take ? Math.ceil(this.totalCount / this.take) : 0;
    }

    public getPageFromTakeAndSkip(take: number, skip: number): number {
        return take ? Math.floor(skip / take) + 1 : 1;
    }

    public getSkipFromPage(page: number): number {
        return page > 0 ? this.take * (page - 1) : 0;
    }

    public getCountAtPageStart(): number {
        return this.skip + 1;
    }

    public getCountAtPageEnd(): number {
        const upperRange = this.skip + this.take;
        return upperRange > this.totalCount ? this.totalCount : upperRange;
    }

    public handleTakeChange(newTake: number): void {
        const previousSkip = this.skip;
        const previousTake = this.take;
        const newSkip = 0;

        if (previousTake !== newTake) {
            this.takeChange.emit(newTake);
        }
        if (previousSkip !== newSkip) {
            this.skipChange.emit(newSkip);
        }
    }

    // Event handlers.
    public incrementPage(direction: Paging): void {
        if (this.isLoading) {
            return;
        }

        let newSkip = direction === Paging.Next ? this.skip + this.take : this.skip - this.take;

        if (newSkip < 0) {
            newSkip = 0;
        }

        this.handlePageChange(this.getPageFromTakeAndSkip(this.take, newSkip));
    }

    public handlePageChange(newPage?: number): void {
        let newSkip = this.skip;
        if (typeof newPage !== 'undefined') {
            newSkip = this.getSkipFromPage(newPage);
        }
        if (newSkip !== this.skip) {
            if (newSkip < this.totalCount) {
                this.skipChange.emit(newSkip);
            } else if (newSkip >= this.totalCount) {
                this.skipChange.emit(this.getSkipFromPage(this.pageCount));
            }
        }
    }
}
